import * as d3 from 'd3';
import * as c3 from 'c3';
import Chart from 'src/javascripts/components/Chart';
import Spinner from 'src/javascripts/components/utilities/Spinner';
import SetColors from 'src/javascripts/components/charts/helpers/SetColors';
import RatingsChartTooltip from 'src/javascripts/components/charts/tooltips/RatingsChartTooltip';
import FormatString from 'src/javascripts/components/utilities/FormatString';

export default class TrendRatings extends Chart {

  getData() {

    // Set chart element id
    const chartId = this.el.attr('id');

    // Set a spinner to indicate chart loading
    Spinner(this.el);

    // Set line color for render phase
    this.lineColor = this.el.attr('data-line-color') || '#00A9EB';

    // Get data from element if present
    let dataStr = this.el.attr('data-trend');
    let data = dataStr ? JSON.parse(dataStr) : undefined;
    if (typeof data !== 'undefined') { return data; }

    // Get data from url
    let url = this.el.attr('data-api-url');
    return $.getJSON(url);

  }

  render(data) {

    // Set id
    let chartId = this.el.attr('id');

    // If no data, replace chart with message
    if ((data.length === 0) || (data.data.length === 0)) {
      $('#' + chartId).find('.spinner-container').remove();
      $('#' + chartId).empty().append('<div class=\'text-gray500\'>No trend data available yet</div>');
      return;
    }

    // Set ratings
    let ratings = data.data;

    // Set earliest date (exclude from time series axis below; gets cut off)
    let earliest_date = ratings[0][ratings[0].length - 1]

    // Set whether to include letter ratings
    let letterGrades = this.el.attr('data-letter-grades');

    // Render chart
    var chart = c3.generate({
      bindto: '#' + chartId,
      padding: {top: -10, bottom: -10, left: 10, right: 10},
      data: {
        x: 'date',
        columns: ratings,
        type: 'line',
        color: () => this.lineColor
      },
      point: {show: false},
      axis: {
        x: {
          show: true,
          type: 'timeseries',
          tick: {
            format(x, i) {
              let date = new Date(x).toLocaleDateString('en-US', {month: 'short', year: 'numeric'});
              let exclude = new Date(earliest_date).toLocaleDateString('en-US', {month: 'short', year: 'numeric'});
              if (date === exclude) {
                return ''
              } else {
                return date;
              }
            }
          }
        },
        y: {
          min: 0,
          max: 100,
          inner: true,
          show: false,
          padding: {bottom: 2},
          tick: {
            outer: false,
            values: [0, 20, 40, 60, 80, 100],
            format(v, id, i, j) { return v; }
          }
        }
      },
      regions: [
        {axis: 'y', start: 0, end: 20, class: 'bg-f-rating'},
        {axis: 'y', start: 20, end: 40, class: 'bg-d-rating'},
        {axis: 'y', start: 40, end: 60, class: 'bg-c-rating'},
        {axis: 'y', start: 60, end: 80, class: 'bg-b-rating'},
        {axis: 'y', start: 80, end: 100, class: 'bg-a-rating'}
      ],
      legend: {show: false},
      tooltip: {
        format: {},
        contents(d, defaultTitleFormat, defaultValueFormat, color) {
          return RatingsChartTooltip(chart, this, d, defaultTitleFormat, defaultValueFormat, 'rating', 2, color, letterGrades);
        }
      },
      grid: {
        y: {show: false},
        x: {show: false}
      }
    });

    // Set ratings metrics
    let high = FormatString(parseFloat(data.high), 'rating', 1, false, true, false, letterGrades);
    let low = FormatString(parseFloat(data.low), 'rating', 1, false, true, false, letterGrades);
    let avg = FormatString(parseFloat(data.avg), 'rating', 1, false, true, false, letterGrades);
    let change = FormatString(parseFloat(data.change), 'decimal', 2, true, true, false, letterGrades);
    let summaryTable = $('#' + chartId).closest('.Card').find('.historical-ratings-summary');
    summaryTable.find('.annual-high').empty().append(high);
    summaryTable.find('.annual-low').empty().append(low);
    summaryTable.find('.annual-avg').empty().append(avg);
    summaryTable.find('.annual-change').empty().append(change);

    // Append change to chart indicator
    if (parseFloat(data.change) !== 0) {
      $('#ratingTrend .chart-total-indicator').empty().append(change);
    }

    return chart;
  }

};
